let timeout = null;

/**
 * Debounces and dispatches a custom event after a specified delay.
 *
 * @param {string} eventName - The name of the custom event to dispatch.
 * @param {object} detail - The detail object to include in the event.
 * @param {number} delay - The delay in milliseconds before dispatching the event.
 */
export const debounceEvent = (eventName, detail, delay = 500) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
        document.dispatchEvent(new CustomEvent(eventName, {
            detail
        }));
    }, delay);
};
